import { AgRendererComponent } from 'ag-grid-angular';
import { Component } from '@angular/core';
import { ContactStateCellRendererParams } from '../../contact-list.models';

@Component({
    selector: 'cv-contact-state-cell-renderer',
    templateUrl: './contact-state-cell-renderer.component.html',
    styleUrls: ['./contact-state-cell-renderer.component.scss']
})
export class ContactStateCellRendererComponent implements AgRendererComponent {

    params: ContactStateCellRendererParams;
    value: string;
    color: string;

    private STATE_COLORS: { [color: string]: string } = {
        green: "#3D9649",
        purple: "#7C52BF",
        yellow: "#DC9C24",
        red: "#BD2026",
        blue: "#0078AC",
        orange: "#F24813",
        cyan: "#00BBBD",
        brown: "#A47748",
        pink: "#E74181",
        black: "#000",
    };

    constructor() { }

    refresh(params: ContactStateCellRendererParams): boolean {
        this.params = params;
        if (params.showTotal) this.value = params.valueFormatted;
        else this.value = params.data.State;
        if (params.customColorGetter)
            this.color = params.customColorGetter(params.data.State);
        else this.color = this.getStateColor(params.data.State);
        return true;
    }

    agInit(params: ContactStateCellRendererParams): void {
        this.params = params;
        if (params.showTotal) this.value = params.valueFormatted;
        else this.value = params.data.State;
        if (params.customColorGetter)
            this.color = params.customColorGetter(params.data.State);
        else this.color = this.getStateColor(params.data.State);
    }

    getStateColor(stateName: any) {
        switch (stateName) {
            case 'Active':
            case 'ACTIVE':
                return this.STATE_COLORS['green'];
            case 'Transfer':
            case 'TRANSFER':
                return this.STATE_COLORS['purple'];
            case 'Hold':
            case 'HOLD':
                return this.STATE_COLORS['yellow'];
            case 'Outbound':
            case 'OUTBOUND':
                return this.STATE_COLORS['brown'];
            case 'Conference':
            case 'CONFERENCE':
                return this.STATE_COLORS['cyan'];
            case 'Inqueue':
            case 'INQUEUE':
                return this.STATE_COLORS['orange'];
            default:
                return this.STATE_COLORS['blue'];
        }
    }
}

